import React from "react";
import { Link } from "react-router-dom";

interface CustomLinkProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
}

const CustomLink: React.FC<CustomLinkProps> = ({
  href,
  children,
  className = "",
}) => {
  // Check if it's an external link
  if (href && (href.startsWith("http://") || href.startsWith("https://"))) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "rgb(var(--brand-600))",
          textDecoration: "underline",
          cursor: "pointer",
        }}
        className={className}
      >
        {children}
      </a>
    );
  }

  // Check if it's a fragment link (starts with #)
  if (href && href.startsWith("#")) {
    const handleFragmentClick = (e: React.MouseEvent) => {
      e.preventDefault();
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    return (
      <a
        href={href}
        onClick={handleFragmentClick}
        style={{
          color: "rgb(var(--brand-600))",
          textDecoration: "underline",
          cursor: "pointer",
        }}
        className={className}
      >
        {children}
      </a>
    );
  }

  // Internal navigation using React Router
  if (href) {
    return (
      <Link
        to={href}
        style={{
          color: "rgb(var(--brand-600))",
          textDecoration: "underline",
          cursor: "pointer",
        }}
        className={className}
      >
        {children}
      </Link>
    );
  }

  // Fallback for cases where href is not provided
  return <span className={className}>{children}</span>;
};

export default CustomLink;
